import { Anchor, Card, Container, Group, Stack, Table, Text, ThemeIcon, Title } from '@mantine/core'
import { createFileRoute, Link } from '@tanstack/react-router'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LuArrowLeft, LuScrollText } from 'react-icons/lu'
import { DataTable } from '@/frontend/components/marina/DataTable'
import { useAuditLogs } from '@/frontend/hooks/useSettings'

export const Route = createFileRoute('/dashboard/settings/audit')({
  component: AuditPage,
})

function AuditPage() {
  const { t } = useTranslation()
  const [filter, setFilter] = useState('')
  const { data, isLoading } = useAuditLogs(filter || undefined)
  const items = data?.items ?? []

  return (
    <Container size="xl" py="md">
      <Stack gap="md">
        <Group gap="sm" align="center">
          <Anchor component={Link} to="/dashboard/settings" c="dimmed" style={{ display: 'flex' }}>
            <LuArrowLeft size={18} />
          </Anchor>
          <ThemeIcon variant="light" color="laut" size="lg" radius="md">
            <LuScrollText size={18} />
          </ThemeIcon>
          <div>
            <Title order={2} ff="var(--font-display)" fw={600}>
              {t('page.settings.audit.title')}
            </Title>
            <Text size="xs" c="dimmed">
              {t('page.settings.audit.subtitle')}
            </Text>
          </div>
        </Group>

        <Group justify="flex-end">
          <input
            type="search"
            value={filter}
            placeholder={t('page.settings.audit.placeholder')}
            onChange={(e) => setFilter(e.target.value)}
            style={{
              fontSize: '0.8rem',
              padding: '6px 12px',
              borderRadius: 8,
              border: '1px solid var(--mantine-color-default-border)',
              background: 'var(--app-card-bg)',
              color: 'inherit',
              width: 280,
              outline: 'none',
            }}
          />
        </Group>

        <Card radius="md" padding="lg">
          <DataTable
            isEmpty={!isLoading && items.length === 0}
            emptyLabel={t('page.settings.audit.empty')}
            page={1}
            pageSize={100}
            total={items.length}
            columns={
              <>
                <Table.Th>{t('page.settings.audit.col_time')}</Table.Th>
                <Table.Th>{t('page.settings.audit.col_user')}</Table.Th>
                <Table.Th>{t('page.settings.audit.col_action')}</Table.Th>
                <Table.Th>{t('page.settings.audit.col_detail')}</Table.Th>
                <Table.Th>{t('page.settings.audit.col_ip')}</Table.Th>
              </>
            }
          >
            {items.map((e) => (
              <Table.Tr key={e.id}>
                <Table.Td>
                  <Text size="xs" c="dimmed">
                    {dayjs(e.createdAt).format('DD MMM YYYY')}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {dayjs(e.createdAt).format('HH:mm:ss')}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{e.user?.name ?? '—'}</Text>
                  <Text size="xs" c="dimmed">
                    {e.user?.email ?? e.userId ?? '—'}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm" ff="var(--mantine-font-family-monospace, monospace)" fw={500}>
                    {e.action}
                  </Text>
                </Table.Td>
                <Table.Td>
                  <Text size="sm">{e.detail ?? '—'}</Text>
                </Table.Td>
                <Table.Td>
                  <Text size="xs" c="dimmed">
                    {e.ip ?? '—'}
                  </Text>
                </Table.Td>
              </Table.Tr>
            ))}
          </DataTable>
        </Card>
      </Stack>
    </Container>
  )
}
